var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getPermission.loads.view || _vm.getPermission.stc.view || _vm.getPermission.stcExtraCost.view)?_c('div',{staticClass:"print"},[_c('md-tabs',{staticClass:"load-and-bill-tabs",attrs:{"md-sync-route":""}}),_c('router-view')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }